/* eslint-disable */
import React from "react";
import MinervaLogo from "../../../../../Assets/Images/Defaults/EquippedLogo.svg";
import A_LinearIndeternment from "../../../Atoms/Feedback/ProgressIndicators/A_LinearIndeternment";
import "./M_RedirectToLogin.scss";
import { log_info } from "../../../../../Utils/logger/logger";
import { useMediaQuery } from "@material-ui/core";

const M_GuestWelcomeCard = (props) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  log_info("Redicting to login screen.");
  return (
    <span style={{ width: isMobile ? "" : "25%" }}>
      <img
        className="redirect-login-image"
        src={MinervaLogo}
        alt="Minerva Logo"
        width="100%"
      />
      <A_LinearIndeternment />
    </span>
  );
};

export default M_GuestWelcomeCard;
